import { useSelector } from 'react-redux';
import { getX50Number } from '../selectors';

export const useGameNumber = () => useSelector(getX50Number);
